import BaseModel from "lib/model";

export default BaseModel.extend({
    idAttribute: "id",
    url: function () {
        if (this.isNew()) {
            return `/api/v3.0/catalog/${this.collection.parent.id}/restrictions`;
        }
        return `/api/v3.0/catalog/${this.collection.parent.id}/restriction/${this.id}`;
    },
    props: {
        id: "objectId",
        field: {
            type: "string",
            values: ["currency_code", "customer_group", "subteam"],
            default: "item",
            requied: true,
        },
        value: { type: "string", required: true },
        mode: { type: "string", required: true },
    },
});
